module.exports = __webpack_public_path__ + "media/images/home_page_go_to_cw-c2b6abc42f03e9b7411f29e73957c4be.png";